<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="55rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">{{t('message.groupInformation')}}</div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>

      <v-divider class="mb-4"></v-divider>
      <!--content-->
      <v-card-text>
        <div class="form-group row-ty">
          <div class="form-row">
            <div class="txt-tit">
              {{t('message.groupName')}}<span class="imp">*</span>
            </div>
            <div class="row">
              <c-Input :placeholder="t('message.enterGroupName')" v-model="companyName" :name="'companyName'" @keydown.enter.prevent/>
            </div>
          </div>
          <div class="form-row">
            <div class="txt-tit">
              {{t('message.groupAdminId')}}
              <c-tooltip v-bind="managerTooltip"/>
            </div>
            <div class="row">
              <c-InputIdAdd :isShowLoading="true" :type="'company'"/>
            </div>

          </div>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class=" d-flex justify-end">
        <c-btn02 v-bind="btnDel" @click.prevent="dialogModel=true"/>
        <c-btn01 v-bind="btnSave" @click="validateAll"/>
      </v-card-actions>
    </v-card>
    <!--삭제-->
    <c-dialog v-model="dialogModel"
              v-bind="dialogBind"
              @close="dialogModel=false"
              @confirm="confirmDelete"
    />
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import * as yup from "yup";
import OrganizationService from "@/services/organization.service";
import utils from "@/common/Utils";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
  companyName: yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const companyName = ref('')
const dialogModel = ref(false)

//ui
const dialogBind = computed(() =>({
  dialogTit: t('message.delete'),
  dialogText: t('message.confirmDeleteSelectedGroup'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}))
const managerTooltip = computed(() =>({
  TooltipText: t('message.adminWillBeCreatedAsNewUser')
}))
const btnDel = computed(() =>({
  btnText: t('message.delete'),
  btnType: 'reset'
}))
const btnSave = computed(() =>({
  btnText: t('message.save'),
  btnType: 'button'
}))

//hook
onBeforeUpdate (()=>{
  companyName.value = ''
  storeRef.adminList.value = []
})

onUpdated (() => {
  if(!dialog.value)
    return;

  let params = {
    idx: storeRef.popupIdx.value,
  }

  if(params.idx){
    OrganizationService.getCompanyAdm(params).then(
      (response) => {
        companyName.value = response.result.companyName
        storeRef.adminList.value = response.result.adminList
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
})

//function
const validateAll = async () => {
  const result = await validate() // 전체 필드 검증 실행
  if(result.valid)
    handleForm()
}

function handleForm(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{

    let params = {
      idx: storeRef.popupIdx.value,
      clientIdx: localStorage.getItem('clientIdx'),
      companyName: companyName.value,
      adminList: Array.from(storeRef.adminList.value)
    }

    OrganizationService.insertUpdateCompanyAdm(params).then(
      (response) => {
        emit('close', 'refresh')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

function confirmDelete(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    let companyIdx = storeRef.popupIdx.value
    if(utils.isEmpty(companyIdx))
      utils.movePage('/login')
    let params = {
      idx: companyIdx,
      delYn: 'Y',
    }

    OrganizationService.insertUpdateCompanyAdm(params).then(
      (response) => {
        emit('close', 'refresh')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
</script>


<style lang="scss">
</style>
